/* Toast — React replacement for the prototype's imperative toast() helper.
   Provides a `useToast()` hook returning showToast(message, sync) and renders
   the toast host inside the module. Auto-dismisses after ~3.2s. */
import React, { createContext, useContext, useCallback, useState } from 'react';

const ToastContext = createContext(() => {});

export function useToast() {
	return useContext(ToastContext);
}

export function ToastProvider({ children }) {
	const [toasts, setToasts] = useState([]);

	const showToast = useCallback((message, sync = false) => {
		const id = Date.now() + Math.random();
		setToasts(prev => [...prev, { id, message, sync, leaving: false }]);
		setTimeout(() => setToasts(prev => prev.map(t => t.id === id ? { ...t, leaving: true } : t)), 3200);
		setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3700);
	}, []);

	return (
		<ToastContext.Provider value={showToast}>
			{children}
			<div className="toast-host">
				{toasts.map(t => (
					<div key={t.id} className={`toast${t.sync ? ' toast--sync' : ''}`}
						style={t.leaving ? { opacity: 0, transition: 'opacity 0.4s' } : undefined}>
						{t.message}
					</div>
				))}
			</div>
		</ToastContext.Provider>
	);
}
